import { createFileRoute } from '@tanstack/react-router'

import { analyzerInsightsSpotsSearchSchema } from '@/pages/analyzer-insights/spots-search'

export const Route = createFileRoute('/_layout/analyzer-insights/spots')({
  validateSearch: analyzerInsightsSpotsSearchSchema,
})
